import {getDutchSideCode} from './dutch_side_codes.ts';
import {getBelgianSideCode} from './belgian_side_codes.ts';
import {getGermanSideCode} from './german_side_codes.ts';
import {IdentifierCountry} from '../enums/identifier_country.ts';

export function getLicensePlateCountry(license_plate: string) {
    const dutchSideCodeIndex = getDutchSideCode(license_plate);
    if (dutchSideCodeIndex !== null) {
        return IdentifierCountry.NL;
    }
    const belgianSideCodeIndex = getBelgianSideCode(license_plate);
    if (belgianSideCodeIndex !== null) {
        return IdentifierCountry.B;
    }
    const germanSideCodeIndex = getGermanSideCode(license_plate);
    if (germanSideCodeIndex !== null) {
        return IdentifierCountry.DE;
    }

    return IdentifierCountry.NL;
}
